export default __webpack_public_path__ + "static/media/Ic_practice time.afb25a03.svg";